export default __webpack_public_path__ + "static/media/ΔΕΗ_ΗΛ.06761395.png";